Backbone.Marionette.Region.Dialog = Backbone.Marionette.Region.extend({
	el : '#modal-region',
	onShow: function(){
		this.currentView.$el.on('hidden', function(){
			$('.plupload').remove();
		})
	},
  });